import { HttpKyClient } from '@/shared/http/ky.adapter';
import { ENDPOINT, type GetAvailableScheduleResponse } from '../types/get-avaible-schedule';
import { HttpMethod } from '@/shared/contracts/http-client.contract';

export type UseCaseInput = {
  slug: string;
};

export type UseCaseOutput = GetAvailableScheduleResponse;

export class GetAvailableScheduleUseCase {
  private http: HttpKyClient;

  constructor(http: HttpKyClient) {
    this.http = http;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { slug } = input;

    if (!slug) {
      throw new Error('Store slug is required');
    }

    const response = await this.http.sendRequest<UseCaseOutput, void>({
      endpoint: ENDPOINT(slug),
      method: HttpMethod.GET,
    });

    return response;
  }
}
